import * as React from 'react';
import {
    Typography,
    Container,
    Box, Grid
} from '@mui/material';
import CommunityCard from "../community/CommunityCard";
import Slider from "react-slick";
import { useDarkMode } from "../darkMode/hook/useDarkMode";


const EstablishmentCommunity = ({communities, header}) => {
    const { mode } = useDarkMode();
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        centerPadding: '-15px',
        centerMode: true,
        slidesToShow: communities.length < 3 ? communities.length : 3,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    variableWidth : false,
                    arrows : false,
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    variableWidth : false,
                    centerPadding: '0px',
                },
            }
        ],
        variableWidth : false
    };
    return (
        <Container className={'container'} style={{marginBottom:30}}>
            <Box maxWidth="lg" style={{marginTop:30,marginBottom:30}}>
                <Typography variant={"h3"} style={{color : mode.settings.textColor3}}>Communautés liées à cet établissement</Typography>
            </Box>
            <Slider {...settings}>
                {communities.map((community, index) => (
                    <div key={index}>
                        <CommunityCard
                            community={community}
                            sx={{
                                width: {xs : '360px' , md : '380px', lg : '380px'},
                                ml: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                                mr: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                            }}
                        />
                    </div>
                ))}
            </Slider>
        </Container>
    )
}

export default EstablishmentCommunity;
